import "./index.css";
import type { IFieldAccessory } from "./types";
import { clsx } from "clsx";

export const FieldAccessory = ({
  size = "md",
  children,
  className,
}: IFieldAccessory) => {
  const rootClass = clsx(
    `nuco-field-accessory nuco-field-accessory--${size}`,
    className,
  );

  return <div className={rootClass}>{children}</div>;
};
